import { theme } from '@traba/theme'

export const MRT_CELL_COMMON_STYLES = {
  padding: '4px',
  fontSize: '12px',
  fontWeight: '300',
  border: '0px',
  borderBottom: `1px solid ${theme.colors.Grey20}`,
}

export const MRT_HEADER_CELL_STYLES = {
  ...MRT_CELL_COMMON_STYLES,
  color: theme.colors.MidnightBlue,
  whiteSpace: 'normal',
  wordWrap: 'break-word',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  '& *': {
    fontWeight: 'bolder',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    fontSize: '10px',
  },
  paddingTop: '0px',
  paddingBottom: '0px',
  borderBottom: 'none',
  justifyContent: 'center',
}

export const MRT_HEADER_ROW_STYLES = {
  paddingRight: '12px',
  paddingLeft: '12px',
  paddingTop: '2px',
  paddingBottom: '2px',
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  backgroundColor: theme.colors.Grey20,
  boxShadow: 'none',
}
